<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="2">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportDataStaticReportChart()" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              border default-expand-all
              stripe :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
    :cell-style="{'text-align':'center'}">
      <el-table-column prop="ID" label="序号">
        <template slot-scope="scope">
          <span>{{scope.$index +1}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="censusDate" label="日期" />
      <el-table-column prop="generalOrderNums" label="普通放单量" />
      <el-table-column prop="generalReciveOrderNums" label="普通接单量" />
      <el-table-column prop="browserOrderNums" label="浏览单放单量" />
      <el-table-column prop="browserReciveOrderNums" label="浏览单接单量" />
      <el-table-column prop="newCustomerNums" label="新注册买手" />
      <el-table-column prop="newBusinessNums" label="新注册商家" />
      <el-table-column prop="releaseOrderBusinessNums" label="放单商家" />
      <el-table-column prop="reciveOrderCustomerNums" label="接单买手数" />
      <el-table-column prop="bindShopNums" label="店铺绑定数" />
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {queryordercensus, queryOrderProfit} from "../../api/b2cbusiness/b2c_admin";
import qs from "qs";
export default {
  name: "StatisticeReportChart",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  methods: {
    exportDataStaticReportChart(){
      window.open("https://api.weiquanai.com/b2cadmindatacharts/exportordercensus?"+qs.stringify({
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1,
      }), "_blank");
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
    setData(data){
      console.log(data)
      if (data.success){
        this.tableData = data.data.records;
        this.pagination.pageNum = data.data.current;
        this.pagination.pageSize = data.data.size;
        this.pagination.total = data.data.total;
      }
    },
    getData(){
      queryordercensus(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      })
    }
  },
  beforeRouteEnter(to, from, next){
    queryordercensus({},{pageNum: 1, pageSize: 20}).then(res=>{
      next(vm => vm.setData(res));
    });
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
